"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbarcodesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbarcodesm` : '') + (description ? ` desc-brandedbarcodesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbarcodesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbarcodesm"
  }, description), /*#__PURE__*/_react.default.createElement("rect", {
    x: "2.83502",
    y: "2.0737",
    width: "18.33",
    height: "13.8338",
    rx: "0.256723",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.89 3.49c.37 0 .66.3.66.66v9.07a.66.66 0 0 1-1.34 0V4.15c0-.37.3-.66.68-.66Zm3.05 0c.37 0 .67.3.67.66v5.04c0 .36-.3.66-.67.66a.66.66 0 0 1-.67-.66V4.15c0-.37.3-.66.67-.66Zm9.17 0c.37 0 .67.3.67.66v9.07c0 .36-.3.66-.67.66a.66.66 0 0 1-.66-.66V4.15c0-.37.3-.66.66-.66Zm-3.05 0c.37 0 .67.3.67.66v5.04c0 .36-.3.66-.67.66a.66.66 0 0 1-.67-.66V4.15c0-.37.3-.66.67-.66Zm-3.06 0c.37 0 .67.3.67.66v5.04c0 .36-.3.66-.67.66a.66.66 0 0 1-.67-.66V4.15c0-.37.3-.66.67-.66Zm3.39 7.56c.37 0 .67.3.67.66 0 .36-.3.66-.67.66H8.56a.66.66 0 0 1-.67-.66c0-.37.3-.66.67-.66h6.83ZM4.36-.01c.37 0 .67.3.67.66 0 .36-.3.66-.67.66h-2.4v2.36c0 .34-.24.61-.57.66H1.3a.66.66 0 0 1-.67-.66V.65C.63.3.93 0 1.3 0h3.06ZM22.7 0c.37 0 .67.3.67.66v3.02c0 .37-.3.66-.67.66a.66.66 0 0 1-.67-.66V1.31h-2.39a.67.67 0 0 1-.66-.57V.65c0-.36.3-.66.66-.66h3.06ZM1.3 13.65c.37 0 .67.3.67.66v2.37h2.39c.34 0 .62.24.66.56v.1c0 .36-.3.65-.66.65H1.3a.66.66 0 0 1-.67-.66v-3.02c0-.36.3-.66.67-.66Zm21.4 0c.37 0 .67.3.67.66v3.02c0 .37-.3.66-.67.66h-3.06a.66.66 0 0 1-.67-.66c0-.36.3-.65.67-.65h2.39V14.3c0-.33.25-.6.58-.65h.09Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedbarcodesm;